module.exports = __webpack_public_path__ + "assets/img/RemoveBtn.ef7e2edf.png";